<script>

import { Vue3Lottie } from 'vue3-lottie'
import LoadingPage from "../../assets/json/LoadingPage.json"

export default {
  name:'LoadingPage',
  components: {
    Vue3Lottie,
  },

  setup(){

    return{

      LoadingPage

    }
  }
}

</script>

<template>

  <Vue3Lottie class="loading" :animationData="LoadingPage" :height="200" :width="200" />
<!--  <div class="loading font-3 font-bold">loading</div>-->

</template>

<style scoped>


</style>